/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModInvoices: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M10.0001 -0.000244141V4.00076H14.0001L10.0001 -0.000244141Z' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.99969 -4.41406e-05H2.99969C2.44769 -4.41406e-05 1.99969 0.447956 1.99969 0.999956V15C1.99969 15.553 2.44769 16 2.99969 16H12.9997C13.5527 16 13.9997 15.553 13.9997 15V4.99996H8.99969V-4.41406e-05ZM11.9997 6.95296C11.2397 6.36396 10.2967 5.99996 9.26069 5.99996C7.30369 5.99996 5.65569 7.25596 5.03569 8.99996H3.99969V9.99996H4.81069C4.80518 10.0511 4.79835 10.1018 4.79153 10.1525C4.77609 10.2671 4.76069 10.3814 4.76069 10.5C4.76069 10.6186 4.77609 10.7328 4.79153 10.8474C4.79835 10.8981 4.80518 10.9488 4.81069 11H3.99969V12H5.03569C5.65569 13.744 7.30369 15 9.26069 15C10.2927 15 11.2327 14.639 11.9917 14.054L11.3627 13.28C10.7757 13.726 10.0527 14 9.26069 14C7.86969 14 6.67569 13.178 6.11169 12H9.99969V11H5.81069C5.80893 10.9878 5.80715 10.9757 5.80538 10.9635C5.78301 10.8108 5.76069 10.6584 5.76069 10.5C5.76069 10.3415 5.78301 10.1891 5.80538 10.0364C5.80715 10.0242 5.80893 10.0121 5.81069 9.99996H9.99969V8.99996H6.11169C6.67569 7.82196 7.86969 6.99996 9.26069 6.99996C10.0597 6.99996 10.7877 7.27996 11.3777 7.73196L11.9997 6.95296Z'
			/>
		</Svg>
	);
};

export { ModInvoices };
